import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/global-error.tsx");
